import { Checkbox, Table, Tbody, Th, Thead, Tr, Box } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { createRenderProfiler } from '../../../lib/performance/monitoring'
import TableRowItem from './TableRowItem'

export interface Column {
  label: string
  accessor: string
  type: 'string' | 'actions' | 'select' | 'custom'
  width?: string
  Cell?: React.FC<{ row: any }>

  image?: string
  icon?: React.FC
  colors?: {
    bg: string
    text: string
    border: string
  }
}

export interface RowData {
  [key: string]: any
}

interface CustomTableProps {
  columns: Column[]
  data: RowData[]
  onRowClick?: (row: RowData) => void
  onCopyLink?: (row: RowData) => void
  onOpenNewTab?: (row: RowData) => void
  onSearch?: (row: RowData) => void
  onRowIntent?: (row: RowData) => void
  selectedRows: (number | string)[]
  onSelectAll: (isChecked: boolean) => void
  onSelectRow: (id: number | string, isChecked: boolean) => void
  allSelected: boolean
  isIndeterminate: boolean
  tableType: 'people' | 'teams' | 'jobs' | 'skills' | 'aboutorg' | 'documents' | 'content' | 'paths' | 'assets' | 'evaluations' | 'past-requests' | 'leave-requests' | 'leave-balances' | 'attendance' | 'public-holidays' | 'time-tracking-projects' | 'time-tracking-members' | 'time-tracking-activities' | 'accountability-areas' | 'roles'
}

const MasterTable: React.FC<CustomTableProps> = ({
  columns,
  onRowClick,
  data,
  onOpenNewTab,
  onSearch,
  onRowIntent,
  selectedRows,
  onSelectAll,
  onSelectRow,
  allSelected,
  isIndeterminate,
  tableType,
}) => {
  const { t } = useTranslation()
  const profiler = React.useMemo(() => createRenderProfiler(`table:${tableType}`), [tableType])
  return (
    <React.Profiler id={`table:${tableType}`} onRender={profiler}>
      <Table width="100%" sx={{ tableLayout: 'fixed' }}>
        <Thead>
          <Tr>
            {columns.map((column) => (
              <Th
                key={column.accessor}
                width={column.width}
                bg="transparent"
                color="solid.400"
                textTransform="none"
                letterSpacing="normal"
                fontSize="12px"
                fontWeight="500"
                borderBottomWidth="1px"
                borderColor="solid.50"
                whiteSpace="normal"
                wordBreak="break-word"
                overflowWrap="anywhere"
                py="10px"
              >
                {column.type === 'select' ? (
                  <Checkbox
                    isChecked={allSelected}
                    isIndeterminate={isIndeterminate}
                    onChange={(e) => onSelectAll(e.target.checked)}
                  />
                ) : (
                  column.label
                )}
              </Th>
            ))}
          </Tr>
        </Thead>
        <Tbody>
          {(Array.isArray(data) ? data : []).length === 0 && (
            <Tr>
              <td colSpan={columns.length}>
                <Box textAlign="center" color="gray.500" fontWeight="medium" mt="15%">
                  {t('table.noData')}
                </Box>
              </td>
            </Tr>
          )}
          {(Array.isArray(data) ? data : []).map((row) => (
            <TableRowItem
              key={row.id}
              row={row}
              columns={columns}
              onRowClick={onRowClick}
              onOpenNewTab={onOpenNewTab}
              onSearch={onSearch}
              onRowIntent={onRowIntent}
              selectedRows={selectedRows}
              onSelectRow={onSelectRow}
              tableType={tableType}
            />
          ))}
        </Tbody>
      </Table>
    </React.Profiler>
  )
}

export default MasterTable
